import styled from "styled-components";

export const MusicHallStatusFormStyled = styled.div`
  border-radius: 8px;
  padding: 20px;
  background-color: ${({ theme }) => theme.COLORS.WHITE_1};
  max-width: 400px;
  width: 100%;
  /* ฟอร์มยาวกว่าจอ ให้ scroll ในกล่อง (ปุ่ม Update อยู่ล่างสุด ต้องเลื่อนถึง) */
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  box-sizing: border-box;
  /* หัวข้ออยู่กลาง ไอคอนปิดชิดขวา */
  .f_header {
    position: relative;
    margin-bottom: 20px;
    .f_close {
      position: absolute;
      top: 50%;
      right: -6px;
      transform: translateY(-50%);
      padding: 6px;
      display: flex;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      cursor: pointer;
      &:hover {
        opacity: 0.6;
      }
    }
  }
  .f_tile {
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
  }
  .f_divider {
    margin: 4px 0 16px;
    border-top: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
  }
  /* รวมค่าบริการ / ยอดค้างจ่าย คำนวณเอง กรอกไม่ได้ */
  .sum_row {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    column-gap: 12px;
    .sum_label {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .sum_value {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      .sum_note {
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      }
    }
    &.outstanding .sum_label,
    &.outstanding .sum_value {
      color: ${({ theme }) => theme.COLORS.RED_1};
    }
  }
  .input_wrap {
    margin-bottom: 16px;
    .status_hint {
      margin-top: 8px;
      padding: 8px 10px;
      border-radius: 6px;
      background-color: ${({ theme }) => theme.COLORS.PURPLE_3};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S13};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      line-height: 1.5;
    }
    /* ตัวเลือกสูงขึ้นเพราะมีคำอธิบาย ขยาย max-height เดิม (200px) ให้เห็นครบโดยไม่ต้อง scroll */
    .Dropdown-menu {
      max-height: 340px;
    }
    /* คำอธิบายติดไปกับ label ของ option จึงถูก render ทั้งในช่องที่เลือกแล้วและในรายการ
       ซ่อนตัวในช่อง เพื่อให้ความสูงช่องเท่าเดิม เห็นคำอธิบายเฉพาะตอนกำลังเลือก */
    .opt_desc {
      display: none;
    }
    .Dropdown-option {
      padding: 10px 12px;
      .opt_label {
        display: block;
      }
      .opt_name {
        color: ${({ theme }) => theme.COLORS.BLACK_3};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      }
      .opt_desc {
        display: block;
        margin-top: 3px;
        color: ${({ theme }) => theme.COLORS.GRAY_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S13};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        line-height: 1.4;
      }
      .opt_warn {
        color: ${({ theme }) => theme.COLORS.RED_1};
      }
    }
    .paid_hint {
      margin-top: 6px;
      color: ${({ theme }) => theme.COLORS.RED_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      line-height: 1.4;
    }
    .status_locked {
      margin-top: 6px;
      color: ${({ theme }) => theme.COLORS.RED_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
    }
  }

  .action_layout {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    .btn_action_wrap {
      max-width: 120px;
      width: 100%;
    }
  }
`;
